var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBurundi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7423 3.31714C20.014 -1.09073 11.986 -1.09073 6.25775 3.31708L16 13.0593L25.7423 3.31714Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 18.9623L6.25775 28.7044C11.986 33.1123 20.014 33.1123 25.7423 28.7044L16 18.9622L15.9999 18.9623Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0481 16.0108L3.30591 6.26855C-1.10197 11.9968 -1.10197 20.0248 3.30591 25.7531L13.0481 16.0108Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.951 16.0108L28.6931 25.7531C33.101 20.0248 33.101 11.9968 28.6931 6.26855L18.951 16.0108Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 22.9672C19.8424 22.9672 22.9569 19.8527 22.9569 16.0107C22.9569 12.1687 19.8424 9.0542 16.0004 9.0542C12.1585 9.0542 9.04395 12.1687 9.04395 16.0107C9.04395 19.8527 12.1585 22.9672 16.0004 22.9672Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 11.1411L16.6031 12.1846H17.808L17.2055 13.2281L17.808 14.2716H16.6031L16.0007 15.3151L15.3982 14.2716H14.1934L14.7958 13.2281L14.1934 12.1846H15.3982L16.0007 11.1411Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9382 16.0107L13.5407 17.0542H14.7455L14.1431 18.0977L14.7455 19.1412H13.5407L12.9382 20.1847L12.3357 19.1412H11.1309L11.7333 18.0977L11.1309 17.0542H12.3357L12.9382 16.0107Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0623 16.0107L19.6647 17.0542H20.8696L20.2671 18.0977L20.8696 19.1412H19.6647L19.0623 20.1847L18.4598 19.1412H17.2549L17.8573 18.0977L17.2549 17.0542H18.4598L19.0623 16.0107Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBurundi);
export default __webpack_public_path__ + "static/media/flag_burundi.659f5ed3cd4a166701116e7d29fd700d.svg";
export { ForwardRef as ReactComponent };